import React, { ReactNode } from 'react';

import { Text } from '@fly/core';
import cn from 'classnames';

interface FlyEmptyStateProps {
  title: string;
  description?: string;
  children?: ReactNode;
  className?: string;
}

export const FlyEmptyState: React.FC<FlyEmptyStateProps> = ({
  title,
  description,
  children,
  className,
  ...rest
}) => {
  return (
    <div
      {...rest}
      className={cn(
        'flex h-full min-h-[300px] w-full flex-col items-center justify-center',
        className
      )}
    >
      <Text size='3' color='neutral' highContrast weight='medium'>
        {title}
      </Text>
      {description && (
        <Text
          size='2'
          color='neutral'
          highContrast
          weight='regular'
          className='mt-fly-3 max-w-[378px] text-center'
        >
          {description}
        </Text>
      )}
      {children && <div className='mt-fly-6'>{children}</div>}
    </div>
  );
};
